import i18next from "i18next";
import HttpApi from "i18next-http-backend";
// import fr_FR from "./fr_FR.json";
// import en_GB from "./en_GB.json";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { store } from "../store/configureStore";
import { setLocale } from "../store/actions/authActions";
import { getLocales } from "../api/splashscreen";
import { refreshCart } from "../store/actions/storeActions";
import { initReactI18next } from "react-i18next";
import consola from "consola";

export const initI18Next = async () => {
  const locales = await getLocales();

  const supportedLngs = locales.map((locale) =>
    locale.locale.replace(/_/g, "-")
  );

  i18next
    .use(HttpApi)
    .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
      // debug: true,
      // Used to work with Suspense (remove on index.js too then), however, now that IE is dead it should be fine
      // react: {
      //   useSuspense: false,
      // },
      load: "currentOnly",
      interpolation: { escapeValue: false },
      // If you want to change the default fallback language (if browser language is not available) change the variable in the .env
      // fallbackLng: process.env.REACT_APP_DEFAULT_LOCALE || "fr-FR",
      fallbackLng: false,
      supportedLngs: supportedLngs,
      backend: {
        loadPath:
          process.env.REACT_APP_BACKEND +
          "uploads/language/translations/app.{{lng}}.json",
        parse: JSON.parse,
      },
    })
    .then(() => {
      // This will check a match between current language (or browser detected language on first visit), and
      // frontoffice languages configured in backoffice
      // If browser language is not found -> it should use instance default
      // If browser partial correspondance is found -> it should use this correspondance
      // If full correspondance is found -> it should use this correspondance
      const locale = getCorrespondingLocale(supportedLngs);
      consola.success("Found corresponding locale : " + locale);

      if (i18next.language !== locale) {
        consola.info(`Replacing ${i18next.language} for ${locale}`);
        i18next.changeLanguage(locale);
        store.dispatch(setLocale(locale));
        store.dispatch(refreshCart());
      }
    });
};

initI18Next();

/**
 * @deprecated please use "t()" function instead
 * @param {*} name
 * @param {*} params
 * @returns
 */
// The method we'll use instead of a regular string
export default function Strings(name, params = {}) {
  return i18next.t(name, params);
}

const getCorrespondingLocale = (locales) => {
  const currentLanguage = i18next.language;

  // Check for full correspondance
  const fullcorrespondance = locales.find(
    (locale) => locale === currentLanguage
  );

  if (fullcorrespondance) {
    consola.info("Full correspondance");
    return fullcorrespondance;
  }

  const partialcorrespondance = locales.find(
    (locale) => locale.substring(0, 2) === currentLanguage.substring(0, 2)
  );

  if (partialcorrespondance) {
    consola.info("Partial correspondance");

    return partialcorrespondance;
  }

  consola.info("No correspondance, returns fallback language");
  // Don't use i18next fallbackLng option, to prevent loading of fallback by default
  return process.env.REACT_APP_DEFAULT_LOCALE || "fr-FR";
};
